import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavReportsIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M15.6755 3.2058C15.9774 2.92331 16.4574 2.93285 16.7474 3.22696C17.0373 3.52113 17.0275 3.98884 16.7256 4.27142L13.502 7.55171C13.253 7.78491 12.8733 7.82434 12.5792 7.64788L8.35693 5.1127L4.27827 8.89626C3.97365 9.17602 3.49355 9.16227 3.20641 8.86548C2.91932 8.56864 2.93343 8.10081 3.238 7.82102L7.74006 3.64987C7.98951 3.42078 8.36611 3.3833 8.65795 3.5585L12.8743 6.08984L15.6755 3.2058Z"
          fill="inherit"
        />
        <path
          d="M7.39868 16.2612L7.39882 8.87493C7.39882 8.467 7.73819 8.1363 8.15682 8.1363C8.57537 8.1364 8.91482 8.46706 8.91482 8.87493L8.91468 16.2612C8.91468 16.6691 8.57523 16.9998 8.15668 16.9999C7.73805 16.9999 7.39868 16.6692 7.39868 16.2612ZM15.484 16.2612L15.4841 8.87493C15.4841 8.467 15.8235 8.1363 16.2421 8.1363C16.6607 8.1363 17.0001 8.467 17.0001 8.87493L17 16.2612C17 16.6692 16.6606 16.9999 16.242 16.9999C15.8233 16.9999 15.484 16.6692 15.484 16.2612Z"
          fill="inherit"
        />
        <path
          d="M3.0004 11.7499L3.00027 16.2499C3.00027 16.6641 3.33605 16.9999 3.75027 16.9999C4.16448 16.9999 4.50027 16.6641 4.50027 16.2499L4.5004 11.7499C4.50039 11.3357 4.16461 10.9999 3.7504 10.9999C3.33619 10.9999 3.0004 11.3357 3.0004 11.7499Z"
          fill="inherit"
        />
        <path
          d="M11.5004 11.7499L11.5003 16.2499C11.5003 16.6641 11.8361 16.9999 12.2503 16.9999C12.6645 16.9999 13.0003 16.6641 13.0003 16.2499L13.0004 11.7499C13.0004 11.3357 12.6646 10.9999 12.2504 10.9999C11.8362 10.9999 11.5004 11.3357 11.5004 11.7499Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
